import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {string} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 */
var getCroppedImage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(image, pixelCrop) {
    var canvas, ctx;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            canvas = document.createElement('canvas');
            canvas.width = pixelCrop.width;
            canvas.height = pixelCrop.height;
            ctx = canvas.getContext('2d');

            if (!(ctx === null)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", null);

          case 6:
            ctx.drawImage(image, pixelCrop.x, pixelCrop.y, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
            return _context.abrupt("return", new Promise(function (resolve) {
              canvas.toBlob(function (file) {
                resolve(file);
              }, 'image/jpeg');
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCroppedImage(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default getCroppedImage;